module.exports = __webpack_public_path__ + "img/logobig.156307f2.png";